import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { REGULATIONS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={REGULATIONS} id={id} />;
}

export const Route = createFileRoute("/_app/departments/regulations/$id")({
  component: Edit,
});
